import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SupportedBrowsersService {

  isUnsupportedBrowserAlertClosed: boolean;

  constructor() {
    this.isUnsupportedBrowserAlertClosed = false;
  }

  openChromeDownloadPage() {
    window.open('https://www.google.com/chrome/', '_blank');
  }

  shouldDisplayModal() {
    const isSupportedBrowser = this.isSupportedBrowser();
    const modalHaveBeenShown = this.getModalHaveBeenShown();

    return !isSupportedBrowser && !modalHaveBeenShown;
  }

  shouldDisplayAlert() {
    return !this.isSupportedBrowser() && !this.isUnsupportedBrowserAlertClosed;
  }

  isSupportedBrowser() {
    const chromeVersion = this.getChromeVersion();
    return chromeVersion >= 69;
  }

  private getModalHaveBeenShown() {
    return !!localStorage.getItem('unsupported-browser-popup');
  }

  setModalHaveBeenShown() {
    localStorage.setItem('unsupported-browser-popup', 'true');
  }

  private getChromeVersion() {
    const chromeVersion = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
    return chromeVersion ? parseInt(chromeVersion[2], 10) : 0;
  }

}
